<script lang="ts">
	import { createEventDispatcher } from 'svelte'
	import { slide } from 'svelte/transition'
	import { Popover, PopoverButton, PopoverPanel } from '@rgossiaux/svelte-headlessui'
	import { CheckIcon, LockClosedIcon } from '@rgossiaux/svelte-heroicons/outline'
	import { createPopperActions } from 'svelte-popperjs'
	import { clickOutside } from '$lib/actions/clickOutside'

	import type MenuItem from '$lib/components/menu'
	
	const [popperRef, popperContent] = createPopperActions({
		placement: 'bottom'
	})
	const extraOpts = {
		modifiers: [
			{ name: 'offset', options: { offset: [0, 8] } },
			{
				name: 'flip',
				options: {
					allowedAutoPlacements: ['right', 'left', 'top', 'bottom'],
					rootBoundary: 'viewport'
				}
			}
		]
	}

	const dispatch = createEventDispatcher()

	export let menuItems: MenuItem[] = []
</script>

<Popover let:open>
	<button use:popperRef on:click|stopPropagation class="flex items-center">
		<PopoverButton>
			<slot name="menu-button" />
		</PopoverButton>
	</button>
	<slot {open} />
	<PopoverPanel let:close class="z-50">
		<menu-window
			use:popperContent={extraOpts}
			use:clickOutside
			on:outclick={() => close(null)}
			in:slide|global={{ duration: 200 }}
		>
			{#each menuItems as menuItem (menuItem.name)}
				{#if typeof menuItem.type !== 'undefined' && menuItem.type === 'title'}
					<menu-item-title>{menuItem.name}</menu-item-title>
				{:else if menuItem.type && menuItem.type === 'link'}
					<a on:click={() => close(null)} class="menu-item grow" href={menuItem.url}>
						{menuItem.name}
						{#if typeof menuItem.isChecked !== 'undefined'}
							<div class="w-4" />
							{#if menuItem.isChecked()}
								<CheckIcon class="h-5" />
							{/if}
						{/if}
					</a>
				{:else if menuItem.type && menuItem.type === 'locked'}
					<a on:click={() => close(null)} class="menu-item grow" href={menuItem.url}>
						{menuItem.name}
						{#if typeof menuItem.isChecked !== 'undefined'}
							<div class="w-4" />
							{#if menuItem.isChecked()}
								<CheckIcon class="h-5" />
							{/if}
						{/if}
					</a>
				{:else if typeof menuItem.type === 'undefined'}
					<button
						class="menu-item"
						on:click={() => {
							if (menuItem.event) {
								dispatch(menuItem.event, menuItem.eventDetail)
								close(null)
							}
						}}
					>
						{#if typeof menuItem.isLocked !== 'undefined' && menuItem.isLocked()}
							<LockClosedIcon class="h-5" />
							<div class="grow">{menuItem.name}</div>
							{#if typeof menuItem.isChecked !== 'undefined' && menuItem.isChecked()}
								<div class="w-4" />
								<CheckIcon class="h-5" />
							{/if}
						{:else}
							<div class="grow">{menuItem.name}</div>
							{#if typeof menuItem.isChecked !== 'undefined' && menuItem.isChecked()}
								<div class="w-4" />
								<CheckIcon class="h-5" />
							{/if}
						{/if}
					</button>
				{/if}
			{/each}
		</menu-window>
	</PopoverPanel>
</Popover>
